import dayjs, { OpUnitType, QUnitType } from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(advancedFormat)

export const formatDate = ({
  date,
  format,
  isUtc
}: {
  date: string
  format: string
  isUtc?: boolean
}) => {
  if (!date) return null

  // NOTE: ISO 8601 dates stored in/created by Hasura are in UTC, however
  // they are not formatted correctly with a trailing "Z", which means we need
  // to be explicit about where a date we want to format is in UTC or local
  return isUtc
    ? dayjs.utc(date).local().format(format)
    : dayjs(date).format(format)
}

export const formatDateNZ = (date: string, format: string) => {
  if (!date) return null
  return dayjs.utc(date).tz('Pacific/Auckland').format(format)
}

export const difference = ({
  date1,
  date2 = dayjs().toISOString(),
  isUtc,
  unit = 'day'
}: {
  date1: string
  date2?: string
  isUtc?: boolean
  unit?: QUnitType | OpUnitType
}) => {
  return isUtc
    ? dayjs.utc(date1).diff(date2, unit)
    : dayjs(date1).diff(dayjs(date2), unit)
}

export const determineFinancialYear = (date: string) => {
  // Takes an iso8601 timestamp and returns the NZ financial year it belongs to.
  // Year boundaries follow NZ time (1 April -> 31 March), not UTC.
  const dateObj = dayjs.utc(date).tz('Pacific/Auckland')
  const year = dateObj.year()
  const month = dateObj.month()

  if (month >= 3 && month <= 11) return year + 1
  return year
}
